/**
 * Membantu membersihkan output AI dari bungkus markdown (```json ... ```)
 */
export const cleanJsonString = (str: string): string => {
  let cleaned = str.replace(/```json/g, "").replace(/```/g, "").trim();
  const firstOpen = cleaned.indexOf('{');
  const lastClose = cleaned.lastIndexOf('}');
  if (firstOpen !== -1 && lastClose !== -1 && lastClose > firstOpen) {
    cleaned = cleaned.substring(firstOpen, lastClose + 1);
  }
  return cleaned;
};

export const parseMdsText = async (rawText: string) => {
  try {
    const response = await fetch('/api/gemini', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'parseMdsText', payload: { rawText } })
    });
    
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Failed to fetch from API');
    }
    
    const data = await response.json();
    const rawOutput = data.text || "";
    const jsonStr = cleanJsonString(rawOutput);
    
    if (!jsonStr) throw new Error("AI returned empty or invalid response");
    return JSON.parse(jsonStr);
  } catch (error) {
    console.error("AI Parsing Error Detail:", error);
    throw error;
  }
};

export const getDeepTechnicalReasoning = async (bomData: any, userQuery: string) => {
  try {
    const response = await fetch('/api/gemini', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'getDeepTechnicalReasoning', payload: { bomData, userQuery } })
    });
    
    if (!response.ok) {
      return "Gagal melakukan Deep Reasoning (Server Error).";
    }
    
    const data = await response.json();
    return data.text || "";
  } catch (error) {
    console.error("Thinking Mode Error:", error);
    return "Gagal melakukan Deep Reasoning.";
  }
};

export const analyzeFileContent = async (fileData: { mimeType: string, data: string }, fileName: string) => {
  try {
    const response = await fetch('/api/gemini', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'analyzeFileContent', payload: { fileData, fileName } })
    });
    
    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || 'Failed to analyze file');
    }
    
    const data = await response.json();
    return data.text || "";
  } catch (error) {
    console.error("File Analysis Error:", error);
    throw error;
  }
};
